/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_Send_ErrorInputs */

const vi_einvoice_tax_send_error = /** @type {(inputs: Einvoice_Tax_Send_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi dữ liệu đến cơ quan thuế gặp lỗi`)
};

/**

* @param {Einvoice_Tax_Send_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_send_error = /** @type {((inputs?: Einvoice_Tax_Send_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_Send_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_send_error(inputs)
});